import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect} from "react-router-dom";
import { Provider } from 'react-redux';
import AuthLayout from "layouts/Auth.jsx";
import AdminLayout from "layouts/Admin.jsx";
import { store } from "./store";
import "assets/scss/material-dashboard-pro-react.scss"

 const history = createBrowserHistory();


 if (window.devToolsExtension) {
  window.devToolsExtension.updateStore(store);
}

// Create an enhanced history that syncs navigation events with the store
// const his = syncHistoryWithStore(createBrowserHistory(), store)

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Switch >
        <Route path="/auth" component={AuthLayout} />
        <Route path="/admin" component={AdminLayout} />
        <Redirect from="/" to="/auth/login-page" />
      </Switch>
    </Router>
  </Provider>,
  document.getElementById("root")
);
